import { EdroneShowToast } from "./types";
import { EdroneToastSingleton } from "./edrone-toast-singleton";
import { makeVueToastificationOptions } from "./default-options";
import EdroneToast from "edrone-components/EdroneToast.vue";

const vueToastification = EdroneToastSingleton.getInstance();

const showToast: EdroneShowToast = (message, type, options) => {
  // Merge provided options (e.g., timeout) with type for toastification
  const { vueToastificationType, vueToastificationOptions } = makeVueToastificationOptions({ type, ...options });
  vueToastification(
    {
      component: EdroneToast,
      props: {
        type: vueToastificationType,
        message: message,
      },
    },
    vueToastificationOptions
  );
};

setTimeout(() => {
  window.showToast = showToast;
}, 10);
